var map = {
	"./featured-blogs.de-CH.json": 1208,
	"./featured-blogs.de-DE.json": 1209,
	"./featured-blogs.en-CA.json": 1210,
	"./featured-blogs.en-GB.json": 1211,
	"./featured-blogs.en-IN.json": 1212,
	"./featured-blogs.en-ME.json": 1213,
	"./featured-blogs.en-US.json": 1214,
	"./featured-blogs.es-EM.json": 1215,
	"./featured-blogs.es-ES.json": 1216,
	"./featured-blogs.fr-BE.json": 1217,
	"./featured-blogs.fr-CA.json": 1218,
	"./featured-blogs.fr-CH.json": 1219,
	"./featured-blogs.nl-BE.json": 1220,
	"./featured-blogs.nl-NL.json": 1221,
	"./featured-blogs.pl-PL.json": 1222,
	"./featured-blogs.pt-BR.json": 1223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1207;